import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Accordion from 'lib/Accordion';
import slidersSVG from 'assets/icons/sliders.svg';
import { useDspSettings } from 'customHooks/useDspSettings';
import { getLineLevelCpmSettings } from 'components/pages/DealWithLines/common/Main/Deal/selectors';
import LineCPMSwitch from './LineCPMSwitch';
import BidsSubmissionSwitch from './BidsSubmissionSwitch';
import { OpenMarketplaceSwitch } from './OpenMarketplaceSwitch/OpenMarketplaceSwitch';

const CampaignSettings = (): React.ReactElement | null => {
  const { isSelectedDspSupportingCreativeSubmissionInBidStream, isSelectedDspSupportingOpenMarketplace } =
    useDspSettings();
  const { isLineLevelCpmVisible } = useSelector(getLineLevelCpmSettings);
  const location = useLocation();

  const showBidsSubmissionSwitch =
    isSelectedDspSupportingCreativeSubmissionInBidStream && location.pathname.includes('deal');
  const showLineCpmSwitch = isLineLevelCpmVisible && location.pathname.includes('deal');

  if (!showBidsSubmissionSwitch && !isSelectedDspSupportingOpenMarketplace && !showLineCpmSwitch) return null;

  return (
    <div className="mx-6 mt-3">
      <Accordion
        dataTestId="campaign-settings"
        label="Campaign settings"
        icon={slidersSVG}
        isOpenOnInit={showLineCpmSwitch}
      >
        <div className="grid grid-cols-1">
          {showBidsSubmissionSwitch && <BidsSubmissionSwitch />}
          {showLineCpmSwitch && <LineCPMSwitch />}
          <OpenMarketplaceSwitch />
        </div>
      </Accordion>
    </div>
  );
};

export default CampaignSettings;
